import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { LOCALE } from "../../../properties/Locale";
import {
  Paper,
  Grid,
  Typography,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  Divider,
  DialogContent,
  DialogActions,
  TextField,
} from "@material-ui/core";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import styles from "../../../assets/jss/layouts/appStyle";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles(styles);

export default function GradingCommentComponent(props) {
  const classes = useStyles();

  const [gradingItem, setGradingItem] = React.useState(props.item);
  const [rerender, triggerRerender] = React.useState(false);

  useEffect(() => {
    setGradingItem(props.item);
  }, []);

  const handleClose = () => {};

  const handleChange = (event, name) => {
    let tmp = gradingItem;
    tmp[name] = event.target.value;
    setGradingItem(tmp);
    triggerRerender(!rerender);
  };

  return (
    <div>
      <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            overflowY: "unset",
          },
        }}
      >
        <CardHeader color="theme">
          <h4 className={classes.cardTitleWhite}>{LOCALE.comment}</h4>
        </CardHeader>
        <CardBody>
          <div>
            <DialogContent>
              <Grid item xs={12}>
                {!props.preview ? (
                  <Alert fullwidth="true" severity="info">
                    <AlertTitle>{LOCALE.comment}</AlertTitle>
                    {LOCALE.comment_info_box_text}
                  </Alert>
                ) : (
                  <Alert fullwidth="true" severity="info">
                    <AlertTitle>{LOCALE.comment}</AlertTitle>
                    Коментар од комисија за оценување
                  </Alert>
                )}
              </Grid>
              <br></br>
              <Grid item xs={12}>
                <TextField
                  label="Коментар"
                  onChange={(e) => handleChange(e, "comment")}
                  value={gradingItem && gradingItem.comment}
                  multiline={true}
                  variant="outlined"
                  disabled={props.preview}
                  fullWidth={true}
                  rows={4}
                />
              </Grid>
            </DialogContent>
            <br />
            <Divider />
            {!props.preview ? (
              <DialogActions>
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => props.handleClose()}
                >
                  {LOCALE.cancel}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={() => props.handleClose(gradingItem, props.index)}
                >
                  {LOCALE.save}
                </Button>
              </DialogActions>
            ) : (
              <DialogActions>
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => props.handleClose()}
                >
                  {LOCALE.close}
                </Button>
              </DialogActions>
            )}
          </div>
        </CardBody>
      </Dialog>
    </div>
  );
}
